import React, { useState } from 'react';
import BlockUi from 'react-block-ui';
import Api from '../../api/global.service';
import env from '../../environment';
import transformWord from '../../utils/transformWord.js';

const RELOAD_TIME = 15000; // 15segs

/**
 * Modal de descarga del Padrón completo. Ofrece dos acomodos del mismo dato:
 *  - Por productor: el reporte histórico, un renglón por productor y las
 *    parcelas creciendo en columnas (hasta 9).
 *  - Por parcela: un renglón por parcela, repitiendo los datos del productor.
 */
const ModalPadronCompletoDownload = ({ isOpen, onClose, idCiclo, usaFormatoApodip, etiquetas }) => {
  const [blocking, setBlocking] = useState(false);

  const parcelaSingular = transformWord(etiquetas?.parcela, ['lowercase']) || 'parcela';
  const parcelaPlural = transformWord(etiquetas?.parcela, ['plural', 'lowercase']) || 'parcelas';

  const handleDownload = url => {
    setBlocking(true);

    Api.download(url)
      .then(response => {
        // no file returned, refresh the page since backend need more time
        if (response.data.size === 0) {
          setTimeout(() => window.location.reload(), RELOAD_TIME);
          setBlocking(false);
          return false;
        }

        const fileName = response.headers['content-disposition'].split('filename=')[1];
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        link.click();
        setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 0);

        setBlocking(false);
        onClose();
      })
      .catch(e => {
        console.error('Error descargando el padrón completo:', e);
        setBlocking(false);
      });
  };

  const handleDownloadPorProductor = () => {
    handleDownload(`xls/${usaFormatoApodip ? 'padron_completo_apodip' : 'padron_completo'}/${idCiclo}`);
  };

  const handleDownloadPorParcela = () => {
    handleDownload(`xls/${usaFormatoApodip ? 'padron_completo_parcelas_apodip' : 'padron_completo_parcelas'}/${idCiclo}`);
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1060,
      }}
      onClick={onClose}>
      <BlockUi
        message=""
        blocking={blocking}
        renderChildren={false}
        style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '10px',
          minWidth: '400px',
          textAlign: 'center',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
        onClick={e => e.stopPropagation()}>
        <div style={{ marginBottom: '20px' }}>
          <img src={env.images.icon.xls} alt="Excel Icon" style={{ marginRight: '10px' }} />
          <h4 style={{ margin: 0, color: '#333' }}>Padrón completo</h4>
        </div>

        {blocking ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
            <div className="spinner-border text-warning mr-2" role="status" aria-hidden="true" style={{ height: 24, width: 24 }} />
            <span>Descargando...</span>
          </div>
        ) : (
          <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
            <div style={{ flex: 1 }}>
              <button
                type="button"
                onClick={handleDownloadPorProductor}
                style={{
                  padding: '12px 16px',
                  backgroundColor: env.colors?.primary_500 || '#789D16',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  transition: 'background-color 0.2s',
                  width: '100%',
                  textAlign: 'center',
                }}
                onMouseOver={e => (e.target.style.backgroundColor = env.colors?.primary_300)}
                onMouseOut={e => (e.target.style.backgroundColor = env.colors?.primary_500 || '#789D16')}>
                Por productor
              </button>
              <p style={{ fontSize: '12px', color: '#666', margin: '8px 0 0 0', textAlign: 'center' }}>
                Un renglón por productor; las {parcelaPlural} crecen en columnas
              </p>
            </div>

            <div style={{ flex: 1 }}>
              <button
                type="button"
                onClick={handleDownloadPorParcela}
                style={{
                  padding: '12px 16px',
                  backgroundColor: env.colors?.secondary_300,
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  transition: 'background-color 0.2s',
                  width: '100%',
                  textAlign: 'center',
                }}
                onMouseOver={e => (e.target.style.backgroundColor = env.colors?.secondary_200)}
                onMouseOut={e => (e.target.style.backgroundColor = env.colors?.secondary_300)}>
                Por {parcelaSingular}
              </button>
              <p style={{ fontSize: '12px', color: '#666', margin: '8px 0 0 0', textAlign: 'center' }}>
                Un renglón por {parcelaSingular}; los datos del productor se repiten
              </p>
            </div>
          </div>
        )}

        <button
          type="button"
          onClick={onClose}
          disabled={blocking}
          style={{
            padding: '8px 16px',
            backgroundColor: '#f8f9fa',
            color: '#666',
            border: '1px solid #ddd',
            borderRadius: '5px',
            cursor: blocking ? 'not-allowed' : 'pointer',
            fontSize: '12px',
            opacity: blocking ? 0.6 : 1,
          }}>
          Cancelar
        </button>
      </BlockUi>
    </div>
  );
};

export default ModalPadronCompletoDownload;
